module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VU - Vanuatu.8d8394fc.svg";